import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import * as ExportActions from '../actions';
import { ModTable } from 'core-lib';

export interface GraphicItem {
    id: string;
    dataURI: string;
    type: 'chart' | 'linescale';
    caption?: string;
}

export type ExportItem = ModTable | GraphicItem;


export interface ExportState extends EntityState<ExportItem> {
    enabled: boolean,
    // activePage: number;
    // ids: string[];
    // entities: { [id: string]: ExportItem };
}

const entityAdapter = createEntityAdapter<ExportItem>();

const initialExportState: ExportState = entityAdapter.getInitialState({
    enabled: false
});

export function exportReducer(state: ExportState = initialExportState, action: ExportActions.ExportAction): ExportState {
    switch (action.type) {
        case ExportActions.STAGE_CHART: {
            return entityAdapter.addOne({ ...action.payload, type: 'chart' }, state);
        }

        case ExportActions.STAGE_LINESCALE: {
            return entityAdapter.addOne({ ...action.payload, type: 'linescale' }, state);
        }

        case ExportActions.STAGE_TABLE: {
            if (state.entities[action.payload.id]) {
                return entityAdapter.updateOne({ id: action.payload.id, changes: action.payload }, state);
            } else {
                return entityAdapter.addOne(action.payload, state);
            }
        }

        case ExportActions.STAGE_MANY: {
            return entityAdapter.addMany(action.payload, state);
        }

        case ExportActions.UNSTAGE_ITEM: {
            return entityAdapter.removeOne(action.payload, state);
        }

        case ExportActions.ENABLE_EXPORT: {
            return { ...state, enabled: true };
        }

        case ExportActions.DISABLE_EXPORT: {
            return entityAdapter.removeAll({ ...state, enabled: false });
        }

    }
    return state;
}

// export const exportReducer = createReducer(
//     initialExportState,
//     on(ExportActions.stageItem, (state, action) => {
//         return {
//             ...state,
//             items: [...state.items, action.data]
//         }
//     }),
//     on(ExportActions.unstageItem, (state, action) => ({
//         ...state,
//         items: state.items.filter(item => item.id !== action.id)
//     })),
//     on(ExportActions.setActivePage, (state, action) => ({
//         ...state, activePage: action.index
//     })),
//     on(ExportActions.assignToPage, (state, action) => ({
//         ...state, pages: {
//             ...state.pages,
//             [state.activePage]: [...state.pages[state.activePage], action.data]
//         }
//     })),
//     on(ExportActions.ConfirmPage, state => ({
//         ...state, activePage: null
//     })),
//     on(ExportActions.enableExport, state => ({
//         ...state, enabled: true
//     })),
//     on(ExportActions.disableExport, state => ({
//         ...state, enabled: false
//     })),
//     on(ExportActions.cancelStaging, state => initialExportState)
// );
